import React, { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { Details } from '@shared/modules/details';
import { EngineeringActions } from '@store/actions';
import { EngineeringSelectors } from '@store/selectors';

export const EngineeringDetails: FC<RouteComponentProps> = (
  props: RouteComponentProps,
) => {
  const dispatch = useDispatch();
  const site = useSelector(EngineeringSelectors.getDetailsData);

  useEffect(
    () => (): void => {
      dispatch(EngineeringActions.resetTabsData.done(undefined));
    },
    [],
  );

  return <Details {...props} fuzeID site={site} />;
};
